import { Minus, Plus } from 'lucide-react'
import { useRef } from 'react'

export function NumberControl({ label, unit, value, step, decimals = 0, onChange }: {
  label: string
  unit: string
  value: number
  step: number
  decimals?: number
  onChange: (value: number) => void
}) {
  const startY = useRef<number | undefined>(undefined)
  const adjust = (amount: number) => onChange(Math.max(0, Number((value + amount).toFixed(decimals))))

  return (
    <div
      className="number-control"
      onPointerDown={(event) => { startY.current = event.clientY }}
      onPointerUp={(event) => {
        if (startY.current === undefined) return
        const distance = event.clientY - startY.current
        if (Math.abs(distance) > 24) adjust(distance < 0 ? step : -step)
        startY.current = undefined
      }}
    >
      <span className="eyebrow">{label}</span>
      <div className="number-row">
        <button className="round-step" onClick={() => adjust(-step)} aria-label={`Reducir ${label}`}><Minus size={20} /></button>
        <label className="number-input-wrap">
          <input
            className="number-input"
            value={value}
            inputMode={decimals ? 'decimal' : 'numeric'}
            onChange={(event) => onChange(Math.max(0, Number(event.target.value.replace(',', '.')) || 0))}
            aria-label={label}
          />
          <span>{unit}</span>
        </label>
        <button className="round-step" onClick={() => adjust(step)} aria-label={`Aumentar ${label}`}><Plus size={20} /></button>
      </div>
    </div>
  )
}
